import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    SearchInput,
    SelectInput,
    EditButton,
    ShowButton,
    DeleteButton,
    Show,
    SimpleShowLayout,
    
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import jwt_decode from 'jwt-decode'
import { makeStyles } from '@material-ui/core/styles';
import BoolNumField from '../users/BoolNumField';  
import ErrorBoundary from '../ErrorBoundary';

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },
})




const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

export const BoxFilter = props => (
    <Filter {...props}>
        <SearchInput source="box_num" alwaysOn  placeholder='Box Number'/>
        <DateInput source="ship_date" label="Shipping date"  locales="en-us"/>
    </Filter>
);


const UnitsShow = props => (
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
    >
        <SimpleShowLayout> 
           
            <TextField source="location" label= "Location"  /> 
        </SimpleShowLayout>
    </Show>
);



export const BoxList = ({ classes, permissions, ...props }) => (
    <ErrorBoundary>
    <List 
        {...props}
        classes={classes}
        filters={<BoxFilter />}
        perPage={20}
        sort={{ field: 'ship_date', order: 'DESC' }}
        bulkActionButtons ={false}
        
        >
        <Datagrid >
            <TextField source="box_num" label="Box#" />     
            <DateField source="ship_date" label="Shipping"  locales="en-us"/>
            <BoolNumField source="exported" label="Exported" />
            {//(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 2  && <ShowButton label='View' />
            }
        </Datagrid>
    </List>
    </ErrorBoundary>
);


export default BoxList